import useTranslation from 'next-translate/useTranslation'
import UserButton from '../../common/button/UserButton'
import useDiscussion from '@/hooks/client/Event/useDiscussion'
import { Button } from '@mantine/core'
import dayjs from 'dayjs'
import { useState } from 'react'
import useReplyForms from '@/hooks/client/Event/useReplyForms'

const Discussion = ({ comments, eventId }: { comments: any; eventId: any }) => {
  const { t, lang } = useTranslation('common')
  const { handleSubmit, commentsData, sessionData, form } = useDiscussion({
    comments,
    eventId,
  })

  const commentIds = commentsData.map((data: any) => data.id)
  const { getFormValues, setFormValue } = useReplyForms(
    {
      userId: sessionData?.user.id,
      eventId: eventId,
      comment: '',
      parentId: null,
    },
    commentIds,
  )

  const [showReplyForms, setShowReplyForms] = useState<{
    [key: string]: boolean
  }>({})

  const handleReplyClick = (id: string) => {
    setShowReplyForms(prev => ({ ...prev, [id]: true }))
  }

  const handleReplyFormSubmit = (id: string) => {
    setShowReplyForms(prev => ({ ...prev, [id]: false }))
  }

  const handleFormSubmit = (
    e: React.FormEvent<HTMLFormElement>,
    id: string,
  ) => {
    e.preventDefault()

    const values = getFormValues(id)
    handleSubmit(values)
    setFormValue(id, 'comment', '') // Clear the comment field after submission
    handleReplyFormSubmit(id)
  }

  return (
    <>
      {commentsData.map((data: any) => (
        <div key={data.id} className="py-4">
          <div className="w-28">
            <UserButton
              image={data.User.logoUrl as string}
              name={
                (lang === 'en' ? data.User.name : data.User.nameAr) as string
              }
              username={
                (lang === 'en' ? data.User.name : data.User.nameAr) as string
              }
              date={dayjs(data.createdAt).fromNow()}
            />
          </div>

          <div className="my-2 ml-12">{data.comment}</div>
          <div className="mt-2 ml-12 flex place-content-between">
            <button
              className="px-2 text-[#2a7996] hover:text-[#2a7996] bg-transparent !bg-none font-[500] text-sm border-x border-[#2a7996]"
              type="button"
              onClick={() => handleReplyClick(data.id)}
            >
              {t('Reply')}
            </button>
          </div>
          {showReplyForms[data.id] && (
            <div className="flex flex-row mx-12 my-4">
              <div className="w-16">
                <UserButton
                  image={sessionData?.user?.image as string}
                  name={(sessionData?.user?.name || 'User') as string}
                  username={
                    (sessionData?.user?.name ||
                      sessionData?.user?.username ||
                      'User') as string
                  }
                  email={sessionData?.user?.email as string}
                />
              </div>
              <div className="w-full">
                <form
                  onSubmit={e => {
                    handleFormSubmit(e, data.id)
                  }}
                >
                  <textarea
                    value={getFormValues(data.id)?.comment || ''}
                    onChange={e => {
                      setFormValue(data.id, 'parentId', data.id)
                      setFormValue(data.id, 'userId', sessionData?.user.id)
                      setFormValue(data.id, 'eventId', eventId)
                      setFormValue(data.id, 'comment', e.target.value)
                    }}
                    id={`comment-${data.id}`}
                    name="comment"
                    className="focus:ring-1 border border-gray-300 focus:border-primary-500 focus:ring-primary-500 block w-full rounded-md text-gray-800 focus:outline-none sm:text-sm px-3 py-2"
                  />
                  <div className="mt-4 flex place-content-between">
                    <Button variant="light" type="submit">
                      {t('post')}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {data &&
            data.Replies?.map((reply: any) => (
              <div key={reply.id} className="my-3 ml-20">
                <div className="w-28">
                  <UserButton
                    image={reply.User.logoUrl as string}
                    name={
                      (lang === 'en'
                        ? reply.User.name
                        : reply.User.nameAr) as string
                    }
                    username={
                      (lang === 'en'
                        ? reply.User.name
                        : reply.User.nameAr) as string
                    }
                    date={dayjs(reply.createdAt).fromNow()}
                  />
                </div>
                <div className="my-2 ml-12">{reply.comment}</div>
              </div>
            ))}
        </div>
      ))}
      <div className="flex flex-row mt-12">
        <div className="w-24">
          <UserButton
            image={sessionData?.user?.image as string}
            name={(sessionData?.user?.name || 'User') as string}
            username={
              (sessionData?.user?.name ||
                sessionData?.user?.username ||
                'User') as string
            }
            email={sessionData?.user?.email as string}
          />
        </div>
        <div className="w-full">
          <form
            onSubmit={e => {
              e.preventDefault()
              handleSubmit(form.values)
              form.setFieldValue('comment', '') // Clear the comment field after submission
            }}
          >
            <textarea
              {...form.getInputProps('comment')}
              id="comment"
              name="comment"
              className="focus:ring-1 border border-gray-300 focus:border-primary-500 focus:ring-primary-500 block w-full rounded-md text-gray-800 focus:outline-none sm:text-sm px-3 py-2"
            />
            <div className="mt-4 flex place-content-between">
              <Button variant="light" type="submit">
                {t('post')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default Discussion
